<div class="flex-100 flex-column" style="overflow: hidden; height: max-content;">
    <div *ngIf="!!dataSourceAttentions && this.quickSearchActive"
        class="flex-row align-center-center mxs-5 mys-2 flex-100">
        <mat-form-field class="flex-80">
            <input matInput (keyup)="applyFilter($event)" placeholder="Búsqueda rápida" />
        </mat-form-field>
    </div>

    <div class="header-filters mb-2">
        <!-- <div class="flex-column align-none-none"> -->
        <div class="flex-row align-center-center">
            <mat-form-field class="flex-100 pls-3" style="height: 40px !important;" appearance="outline">
                <mat-select id="cmb_schedule" [(value)]="this.optionSelected"
                    (selectionChange)="this.selectOption($event)" class="subtitle-2">
                    <mat-option value="listado">
                        Listado
                    </mat-option>
                    <mat-option value="calendario">
                        Calendario
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <div class="flex-30"></div>
            <div class="flex-37">
                <span class="subtitle-2 text-secondary-bolder">
                    {{ dateLabel }}
                </span>
            </div>
            @if(!viewColumnsBillAndDebit){
            <div class="flex-row align-end-center gap-1em">
                <button id="btn_add_attention" mat-icon-button matTooltip="Eliminación de atenciones"
                    (click)="deleteAttentions()">
                    <mat-icon svgIcon="Trash-enabled-primary"></mat-icon>
                </button>
                <button id="btn_add_attention" mat-icon-button matTooltip="Agendar" color="primary"
                    (click)="createAttention()">
                    <mat-icon class="mat-icon-22x22" svgIcon="Add-attention-enabled-primary-22x22"></mat-icon>
                </button>
            </div>
            }
        </div>
        <!-- </div> -->
    </div>

    <div class="flex-column"
        *ngIf="(selectedOption === MODULE ? (!!caseModuleSelected?.id || ordersRadioSelected) : ((dataSourceAttentions && dataSourceAttentions.data && (dataSourceAttentions.data.length > 0 || this.actualDateAttentions?.length > 0)) || (dataSourceSupplies && dataSourceSupplies.data && dataSourceSupplies.data.length > 0 && this.actualDateAttentions?.length > 0))); else noAttentions">
            <!-- ========== UNIFIED MODULES TABLE ========== -->
            <div style="overflow-y:auto;" [ngClass]="{'scrollOff': !this.scrollOn}">

                <!-- VISTA 1: Módulos + Prácticas (cuando se selecciona radio de módulo) -->
                <ng-container *ngIf="!ordersRadioSelected">
                <!-- Main Header - Módulos -->
                <div style="text-align: center; background-color: #FFF; border: 1px solid #441d99; padding: 12px; border-radius: 6px 6px 0 0;">
                    <span class="subtitle-2 text-primary-darker">Módulos</span>
                </div>

                <!-- ===== MODULE Attentions ===== -->
                <div style="border: 1px solid #e0e0e0; border-top: none;">
                    <!-- MODULE Attentions Table -->
                    <table class="mat-elevation-z0 flex-100 no-pointer module-table-header modules-unified-table module-table" mat-table [dataSource]="dataSourceModuleAttentions">
                        <!-- Module Name Row - Arrow Column (50px, aligns with checkbox below) -->
                        <ng-container matColumnDef="moduleNameArrow">
                            <th mat-header-cell *matHeaderCellDef
                                class="cursor-pointer col-checkbox"
                                style="background-color: #E8E0F0;"
                                (click)="moduleRowExpanded = !moduleRowExpanded">
                                <mat-icon class="text-secondary">
                                    {{ moduleRowExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                                </mat-icon>
                            </th>
                        </ng-container>

                        <!-- Module Name Row - Name Column (spans rest) -->
                        <ng-container matColumnDef="moduleNameText">
                            <th mat-header-cell *matHeaderCellDef [attr.colspan]="this.showButtonBill ? 5 : 4"
                                class="cursor-pointer bg-on-hover"
                                style="text-align: left !important; padding: 12px 16px; background-color: #E8E0F0;"
                                (click)="moduleRowExpanded = !moduleRowExpanded">
                                <span class="subtitle-2 text-primary-darker">{{ caseModuleName }}</span>
                            </th>
                        </ng-container>

                        <!-- Spacer Column (aligns with checkbox in PRACTICE_MODULE table) -->
                        <ng-container matColumnDef="moduleSpacer">
                            <th mat-header-cell *matHeaderCellDef class="col-checkbox"></th>
                            <td mat-cell *matCellDef="let data"></td>
                        </ng-container>

                        <!-- Date Column (80px, aligns with fromDate in PRACTICE_MODULE) -->
                        <ng-container matColumnDef="moduleDate">
                            <th mat-header-cell *matHeaderCellDef class="col-date"></th>
                            <td mat-cell *matCellDef="let data" class="col-date">
                                <span class="subtitle-3 text-secondary-bolder">{{ data.fromDate | date: 'EEE dd MMM' }}</span>
                            </td>
                        </ng-container>

                        <!-- Módulo Column (rest of space - empty in data rows) -->
                        <ng-container matColumnDef="moduleFromDate">
                            <th mat-header-cell *matHeaderCellDef class="col-module-rest">Módulo</th>
                            <td mat-cell *matCellDef="let data"></td>
                        </ng-container>

                        <!-- Estado Column -->
                        <ng-container matColumnDef="moduleState">
                            <th mat-header-cell *matHeaderCellDef class="col-state">Estado</th>
                            <td mat-cell *matCellDef="let attention" [matTooltip]="this.matTooltipText(attention)"
                                matTooltipClass="multiline-tooltip"
                                style="padding-right: 0px !important; max-width: 80px !important;">
                                <div class="inner-cell inner-cell-auth">
                                    <mat-chip-listbox *ngIf="!attention?.isLoadingStates">
                                        <mat-chip style="white-space: nowrap;"
                                            [ngClass]="{ 'mat-chip-min-width-50px': this.descriptionStateShort }"
                                            [ngStyle]="{'color':this.ATTENTIONS_COLORS[attention.state.id], 'background-color':this.ATTENTIONS_BACKGROUND_COLORS[attention.state.id]}"
                                            selected [disabled]="attention?.isLoadingStates"
                                            (click)="this.stopPropagation($event); !attention?.isLoadingStates ? this.onClickStateAttention(attention):null">
                                            <span class="mat-caption cursor-pointer"
                                                matTooltip="{{ attention.state.name | uppercase }}">{{
                                                this.descriptionStateShort ? ( attention.state.name | firstLetterWordsIntoString
                                                ) : ( attention.state.name | titlecase | uppercase ) }}
                                            </span>
                                        </mat-chip>
                                    </mat-chip-listbox>
                                    <div class="align-center-center">
                                        <mat-spinner diameter="20" *ngIf="attention?.isLoadingStates"></mat-spinner>
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <!-- Actions Menu -->
                        <ng-container matColumnDef="moduleActionsMenu">
                            <th mat-header-cell *matHeaderCellDef class="col-actions"></th>
                            <td mat-cell *matCellDef="let attention">
                                <button mat-icon-button (click)="stopPropagation($event);" matTooltip="Acciones">
                                    <mat-icon class="cursor-pointer text-secondary" [matMenuTriggerFor]="menuActions"
                                        [matMenuTriggerData]="{ attention:attention }"
                                        svgIcon="DotsThreeVertical-enabled-primary-lighter"></mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <!-- Bill/Debit Column for MODULE -->
                        <ng-container matColumnDef="moduleBill-debit">
                            <th mat-header-cell *matHeaderCellDef class="col-bill-debit">
                                <mat-radio-group (click)="$event.stopPropagation()">
                                    <div class="flex-row">
                                        <div class="flex-50 flex-column align-center-center">
                                            <span style="padding: 0px 5px;">Facturar</span>
                                            <mat-icon style="cursor: pointer;" svgIcon="SelectAll-enabled-primary-lighter"
                                                matTooltip="Selecciona todas las atenciones para Facturar"
                                                (click)="this.selectAll('toBill')"></mat-icon>
                                        </div>
                                        <div class="flex-50 flex-column align-center-center">
                                            <span>Debitar</span>
                                            <mat-icon style="cursor: pointer;" svgIcon="SelectAll-enabled-primary-lighter"
                                                matTooltip="Selecciona todas las atenciones para Debitar"
                                                (click)="this.selectAll('toDebit')"></mat-icon>
                                        </div>
                                    </div>
                                </mat-radio-group>
                            </th>
                            <td mat-cell *matCellDef="let attention" class="col-bill-debit">
                                <mat-radio-group style="width: 100%;" (click)="$event.stopPropagation()"
                                    [disabled]="attention.state.id==enumStates.INFORMADA || attention.state.id==enumStates.AGENDADA || attention.state.id==enumStates.EN_CURSO">
                                    <div class="flex-row">
                                        <div class="flex-50 flex-column align-center-center">
                                            <mat-radio-button #buttonB class="subtitle-3 text-primary-darker"
                                                [checked]="validateCheckedBill(attention)" [value]="'toBill'"
                                                (click)="!(attention.state.id==enumStates.INFORMADA || attention.state.id==enumStates.AGENDADA) && !(attention.state.id==enumStates.FACTURABLE) && checkState(attention, buttonB)"
                                                [disabled]="attention.state.id==enumStates.FACTURABLE"></mat-radio-button>
                                        </div>
                                        <div class="flex-50 flex-column align-center-center">
                                            <mat-radio-button #buttonD class="subtitle-3 text-primary-darker"
                                                [checked]="validateCheckedDebit(attention)" [value]="'toDebit'"
                                                (click)="!(attention.state.id==enumStates.INFORMADA || attention.state.id==enumStates.AGENDADA) && !(attention.state.id==enumStates.DEBITADA) && checkState(attention, buttonD)"
                                                [disabled]="attention.state.id==enumStates.DEBITADA"></mat-radio-button>
                                        </div>
                                    </div>
                                </mat-radio-group>
                            </td>
                        </ng-container>

                        <!-- Header rows -->
                        <tr mat-header-row *matHeaderRowDef="this.showButtonBill ? displayedModuleColumnsBillDebit : displayedModuleColumns"></tr>
                        <tr mat-header-row *matHeaderRowDef="['moduleNameArrow', 'moduleNameText']"></tr>
                        <!-- Data rows (collapsible) -->
                        <tr mat-row *matRowDef="let row; columns: this.showButtonBill ? displayedModuleColumnsBillDebit : displayedModuleColumns"
                            class="bg-on-hover"
                            [ngClass]="{'hidden-row': !moduleRowExpanded}"></tr>
                    </table>

                    <!-- Footer for MODULE section -->
                    <div class="flex-row align-start-center py-2 pl-3" style="background-color: #fafafa; border-top: 1px solid #e0e0e0;">
                        <span class="subtitle-3 text-secondary-bolder">TOTAL: {{ moduleAttentions?.length || 0 }}</span>
                    </div>
                </div>

                <!-- ===== PRACTICE_MODULE Attentions (PRACTICES)  ===== -->
                <div *ngIf="practiceModuleAttentions?.length > 1000 " style="border: 1px solid #e0e0e0; border-top: none;">
                    <!-- PRACTICE_MODULE Attentions Table -->
                    <table multiTemplateDataRows class="mat-elevation-z0 flex-100 no-pointer module-table-header modules-unified-table practice-module-table" mat-table [dataSource]="dataSourcePracticeModuleAttentions">

                        <!-- Arrow/Checkbox Column -->
                        <ng-container matColumnDef="checkbox">
                            <th mat-header-cell *matHeaderCellDef class="cursor-pointer col-checkbox" (click)="practiceModuleRowExpanded = !practiceModuleRowExpanded">
                                <mat-icon class="text-secondary">
                                    {{ practiceModuleRowExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                                </mat-icon>
                            </th>
                            <td mat-cell *matCellDef="let row">
                            </td>
                        </ng-container>

                        <!-- dateFrom Column -->
                        <ng-container matColumnDef="fromDate">
                            <th mat-header-cell *matHeaderCellDef class="col-date"></th>
                            <td mat-cell *matCellDef="let data" class="col-date">
                                <span class="subtitle-3 text-secondary-bolder">{{ data.fromDate | date: 'EEE dd MMM' }}</span>
                            </td>
                        </ng-container>

                        <!-- timeRange Column -->
                        <ng-container matColumnDef="timeRange">
                            <th mat-header-cell *matHeaderCellDef class="col-time-range">
                                <div class="flex-column align-center-center">
                                    <span>Horario</span>
                                    <span>agendado</span>
                                </div>
                            </th>
                            <td mat-cell *matCellDef="let data">
                                <span>
                                    {{ this.practiceCountedByHours(data.practice) ? (data.fromDate | date: 'HH:mm') : 'Visita' }}
                                    {{ this.practiceCountedByHours(data.practice) ? ' - ' + (data.toDate | date: 'HH:mm') : '' }}
                                </span>
                            </td>
                        </ng-container>

                            <!-- hours Column -->
                            <ng-container matColumnDef="hours">
                                <th mat-header-cell *matHeaderCellDef class="col-hours">
                                    <div class="flex-column align-center-center">
                                        <span>Hs</span>
                                        <span>declaradas</span>
                                    </div>
                                </th>
                                <td mat-cell *matCellDef="let data">
                                    <span>{{ data.quantity ? (data.quantity < 10 ? '0' + data.quantity : data.quantity) + ':00 hs' : '-' }}</span>
                                </td>
                            </ng-container>

                            <!-- practice Column -->
                            <ng-container matColumnDef="practice">
                                <th mat-header-cell *matHeaderCellDef class="col-practice">Práctica</th>
                                <td mat-cell *matCellDef="let attention" [matTooltip]="attention.practice?.name || ''">
                                    <span class="text-ellipsis">{{ attention.practice?.name || 'Sin datos' }}</span>
                                </td>
                            </ng-container>

                            <!-- provider Column -->
                            <ng-container matColumnDef="provider">
                                <th mat-header-cell *matHeaderCellDef class="col-provider">Prestador</th>
                                <td mat-cell *matCellDef="let attention" [matTooltip]="attention.provider ? attention.provider.surname + ', ' + attention.provider.name : ''">
                                    <span class="text-ellipsis">{{ attention.provider ? attention.provider.surname + ', ' + attention.provider.name : '' }}</span>
                                </td>
                            </ng-container>

                            <!-- state Column -->
                            <ng-container matColumnDef="state">
                                <th mat-header-cell *matHeaderCellDef class="col-state">Estado</th>
                                <td mat-cell *matCellDef="let attention" [matTooltip]="this.matTooltipText(attention)"
                                    matTooltipClass="multiline-tooltip"
                                    style="padding-right: 0px !important; max-width: 80px !important;">
                                    <div class="inner-cell inner-cell-auth">
                                        <mat-chip-listbox *ngIf="!attention?.isLoadingStates">
                                            <mat-chip style="white-space: nowrap;"
                                                [ngClass]="{ 'mat-chip-min-width-50px': this.descriptionStateShort }"
                                                [ngStyle]="{'color':this.ATTENTIONS_COLORS[attention.state.id], 'background-color':this.ATTENTIONS_BACKGROUND_COLORS[attention.state.id]}"
                                                selected [disabled]="attention?.isLoadingStates"
                                                (click)="this.stopPropagation($event); !attention?.isLoadingStates ? this.onClickStateAttention(attention):null">
                                                <span class="mat-caption cursor-pointer"
                                                    matTooltip="{{ attention.state.name | uppercase }}">{{
                                                    this.descriptionStateShort ? ( attention.state.name | firstLetterWordsIntoString
                                                    ) : ( attention.state.name | titlecase | uppercase ) }}
                                                </span>
                                            </mat-chip>
                                        </mat-chip-listbox>
                                        <div class="align-center-center">
                                            <mat-spinner diameter="20" *ngIf="attention?.isLoadingStates"></mat-spinner>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- Actions Menu -->
                            <ng-container matColumnDef="actionsMenu">
                                <th mat-header-cell *matHeaderCellDef class="col-actions"></th>
                                <td mat-cell *matCellDef="let attention">
                                    <button mat-icon-button (click)="stopPropagation($event);" matTooltip="Acciones">
                                        <mat-icon class="cursor-pointer text-secondary" [matMenuTriggerFor]="menuActions"
                                            [matMenuTriggerData]="{ attention:attention }"
                                            svgIcon="DotsThreeVertical-enabled-primary-lighter"></mat-icon>
                                    </button>
                                </td>
                            </ng-container>

                            <!-- Bill/Debit Column -->
                            <ng-container matColumnDef="bill-debit">
                                <th mat-header-cell *matHeaderCellDef class="col-bill-debit">
                                    <mat-radio-group (click)="$event.stopPropagation()">
                                        <div class="flex-row">
                                            <div class="flex-50 flex-column align-center-center">
                                                <span style="padding: 0px 5px;">Facturar</span>
                                                <mat-icon style="cursor: pointer;" svgIcon="SelectAll-enabled-primary-lighter"
                                                    matTooltip="Selecciona todas las atenciones para Facturar"
                                                    (click)="this.selectAll('toBill')"></mat-icon>
                                            </div>
                                            <div class="flex-50 flex-column align-center-center">
                                                <span>Debitar</span>
                                                <mat-icon style="cursor: pointer;" svgIcon="SelectAll-enabled-primary-lighter"
                                                    matTooltip="Selecciona todas las atenciones para Debitar"
                                                    (click)="this.selectAll('toDebit')"></mat-icon>
                                            </div>
                                        </div>
                                    </mat-radio-group>
                                </th>
                                <td mat-cell *matCellDef="let attention" class="col-bill-debit">
                                    <mat-radio-group style="width: 100%;" (click)="$event.stopPropagation()"
                                        [disabled]="attention.state.id==enumStates.INFORMADA || attention.state.id==enumStates.AGENDADA || attention.state.id==enumStates.EN_CURSO">
                                        <div class="flex-row">
                                            <div class="flex-50 flex-column align-center-center">
                                                <mat-radio-button #buttonB class="subtitle-3 text-primary-darker"
                                                    [checked]="validateCheckedBill(attention)" [value]="'toBill'"
                                                    (click)="!(attention.state.id==enumStates.INFORMADA || attention.state.id==enumStates.AGENDADA) && !(attention.state.id==enumStates.FACTURABLE) && checkState(attention, buttonB)"
                                                    [disabled]="attention.state.id==enumStates.FACTURABLE"></mat-radio-button>
                                            </div>
                                            <div class="flex-50 flex-column align-center-center">
                                                <mat-radio-button #buttonD class="subtitle-3 text-primary-darker"
                                                    [checked]="validateCheckedDebit(attention)" [value]="'toDebit'"
                                                    (click)="!(attention.state.id==enumStates.INFORMADA || attention.state.id==enumStates.AGENDADA) && !(attention.state.id==enumStates.DEBITADA) && checkState(attention, buttonD)"
                                                    [disabled]="attention.state.id==enumStates.DEBITADA"></mat-radio-button>
                                            </div>
                                        </div>
                                    </mat-radio-group>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="this.showButtonBill ? displayedPracticeModuleColumnsBillDebit : displayedPracticeModuleColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: this.showButtonBill ? displayedPracticeModuleColumnsBillDebit : displayedPracticeModuleColumns"
                                class="bg-on-hover"
                                [ngClass]="{'hidden-row': !practiceModuleRowExpanded}"></tr>
                        </table>

                    <!-- Footer for PRACTICE_MODULE section -->
                    <div *ngIf="practiceModuleRowExpanded" class="flex-row align-start-center flex-gap-2em py-2 pl-3" style="background-color: #fafafa; border-top: 1px solid #e0e0e0;">
                        <span class="subtitle-3 text-secondary">HORAS: {{ this.totalHours || 0 }}</span>
                        <span class="subtitle-3 text-secondary">TOTAL: {{ this.practiceModuleAttentions?.length || 0 }}</span>
                    </div>
                </div>
                </ng-container>

                <!-- ===== VISTA 2: PEDIDOS (cuando se selecciona radio de pedidos) ===== -->
                <ng-container *ngIf="ordersRadioSelected && orderGroups?.length > 0">
                    <!-- Main Header - Pedidos -->
                    <div style="text-align: center; background-color: #FFF; border: 1px solid #441d99; padding: 12px; margin-top: 16px; border-radius: 6px 6px 0 0;">
                        <span class="subtitle-2 text-primary-darker">Pedidos</span>
                    </div>

                    <!-- Orders Groups Container -->
                    <div style="border: 1px solid #e0e0e0; border-top: none;">
                        <!-- Iterate over each order group (grouped by date) -->
                        <ng-container *ngFor="let orderGroup of orderGroups; let i = index">
                            <!-- Order Group Header Row (expandible) -->
                            <div class="flex-row align-start-center cursor-pointer bg-on-hover"
                                 style="padding: 12px 16px; background-color: #E8E0F0; border-bottom: 1px solid #e0e0e0;"
                                 (click)="toggleOrderGroup(orderGroup)">
                                <mat-icon class="text-secondary mrs-2">
                                    {{ orderGroup.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
                                </mat-icon>
                                <span class="subtitle-2 text-primary-darker">Pedido {{ orderGroup.dateLabel }}</span>
                            </div>

                            <!-- Order Items Table (collapsible) -->
                            <div *ngIf="orderGroup.expanded" style="background-color: #fafafa;">
                                <table mat-table [dataSource]="orderGroup.attentions" class="mat-elevation-z0 flex-100 orders-items-table">

                                    <!-- Date Column (visible only on first row) -->
                                    <ng-container matColumnDef="orderItemDate">
                                        <th mat-header-cell *matHeaderCellDef></th>
                                        <td mat-cell *matCellDef="let attention; let idx = index" style="vertical-align: top; padding-top: 12px;">
                                            <span *ngIf="idx === 0" class="subtitle-3 text-secondary-bolder">
                                                {{ orderGroup.dateLabel }}
                                            </span>
                                        </td>
                                    </ng-container>

                                    <!-- Módulo Column -->
                                    <ng-container matColumnDef="orderItemModule">
                                        <th mat-header-cell *matHeaderCellDef>Módulo</th>
                                        <td mat-cell *matCellDef="let attention">
                                            <span class="subtitle-3 text-primary text-ellipsis" style="max-width: 150px; display: inline-block;">
                                                {{ getModuleNameFromAttention(attention) }}
                                            </span>
                                        </td>
                                    </ng-container>

                                    <!-- Hs de entrega Column -->
                                    <ng-container matColumnDef="orderItemDeliveryTime">
                                        <th mat-header-cell *matHeaderCellDef>Hs de entrega</th>
                                        <td mat-cell *matCellDef="let attention">
                                            <span class="subtitle-3 text-primary">
                                                {{ getDeliveryTime(attention) }}
                                            </span>
                                        </td>
                                    </ng-container>

                                    <!-- Cantidad Column -->
                                    <ng-container matColumnDef="orderItemQuantity">
                                        <th mat-header-cell *matHeaderCellDef>Cantidad</th>
                                        <td mat-cell *matCellDef="let attention">
                                            <span class="subtitle-3 text-primary">
                                                {{ getQuantityWithUnit(attention) }}
                                            </span>
                                        </td>
                                    </ng-container>

                                    <!-- Insumos Column -->
                                    <ng-container matColumnDef="orderItemSupply">
                                        <th mat-header-cell *matHeaderCellDef>Insumos</th>
                                        <td mat-cell *matCellDef="let attention">
                                            <span class="subtitle-3 text-primary">
                                                {{ getSupplyName(attention) }}
                                            </span>
                                        </td>
                                    </ng-container>

                                    <!-- Proveedor Column -->
                                    <ng-container matColumnDef="orderItemProvider">
                                        <th mat-header-cell *matHeaderCellDef>Proveedor</th>
                                        <td mat-cell *matCellDef="let attention">
                                            <span class="subtitle-3 text-primary">
                                                {{ attention.provider?.name || '-' }}
                                            </span>
                                        </td>
                                    </ng-container>

                                    <!-- Estado Column -->
                                    <ng-container matColumnDef="orderItemState">
                                        <th mat-header-cell *matHeaderCellDef>Estado</th>
                                        <td mat-cell *matCellDef="let attention">
                                            <mat-chip-listbox *ngIf="!attention?.isLoadingStates">
                                                <mat-chip style="white-space: nowrap;"
                                                    [ngStyle]="{'color':this.ATTENTIONS_COLORS[attention.state?.id], 'background-color':this.ATTENTIONS_BACKGROUND_COLORS[attention.state?.id]}"
                                                    selected [disabled]="attention?.isLoadingStates"
                                                    (click)="this.stopPropagation($event); !attention?.isLoadingStates ? this.onClickStateAttention(attention):null">
                                                    <span class="mat-caption cursor-pointer">
                                                        {{ attention.state?.name | firstLetterWordsIntoString }}
                                                    </span>
                                                </mat-chip>
                                            </mat-chip-listbox>
                                            <mat-spinner diameter="20" *ngIf="attention?.isLoadingStates"></mat-spinner>
                                        </td>
                                    </ng-container>

                                    <!-- Actions Menu Column -->
                                    <ng-container matColumnDef="orderItemActions">
                                        <th mat-header-cell *matHeaderCellDef></th>
                                        <td mat-cell *matCellDef="let attention">
                                            <button mat-icon-button (click)="stopPropagation($event);" matTooltip="Acciones">
                                                <mat-icon class="cursor-pointer text-secondary" [matMenuTriggerFor]="menuActions"
                                                    [matMenuTriggerData]="{ attention:attention }"
                                                    svgIcon="DotsThreeVertical-enabled-primary-lighter"></mat-icon>
                                            </button>
                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedOrderItemColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedOrderItemColumns" class="bg-on-hover"></tr>
                                </table>

                                <!-- Total for this order group -->
                                <div class="flex-row align-start-center py-2 pl-3" style="border-top: 1px solid #e0e0e0;">
                                    <span class="subtitle-3 text-secondary-bolder">TOTAL: {{ orderGroup.attentions?.length || 0 }}</span>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
            </div>

            <!-- ===== FOOTER: State Chips Filter for Modules ===== -->
            <div *ngIf="this.bottomTotals" class="flex-column flex-100 align-space-between-stretch">
                <div class="flex-row align-start-center flex-gap-1em py-2 pl-1 pr-2 mat-footer-cell"
                    style="border-radius: 0 0 6px 6px;">
                    <span class="subtitle-3 text-secondary-darker margin-left-counters">HORAS:</span>
                    <span class="mls-1 subtitle-3 text-primary">{{ this.totalHours }}</span>
                    <span class="subtitle-3 text-secondary-darker margin-left-counters">TOTAL:</span>
                    <span class="mls-1 subtitle-3 text-primary">{{ this.totalAttentions }}</span>
                </div>
                <div class="flex-row align-space-between-center pl-1">
                    <div class="flex-row wrap align-start-none mts-2 flex-75">
                        <mat-chip-listbox>
                            <div *ngFor="let totalByState of totalsByAttentionsState; let i=index; trackBy: trackByIndex">
                                <div *ngIf="totalByState!=0" class="flex-row align-start-center flex-gap-2em">
                                    <mat-chip style="white-space: nowrap; cursor: pointer;"
                                        [ngClass]="{ 'mat-chip-min-width-50px': this.descriptionStateShort }"
                                        [ngStyle]="{'color':this.getColor(i), 'background-color':this.getBackgroundColor(i), 'border':this.getBorderStyle(i)}"
                                        (click)="this.selectState(i)">
                                        <span class="mat-caption" matTooltip="{{ enumStates[i].split('_').join(' ') }}">
                                            {{ this.descriptionStateShort ? ( enumStates[i].split('_').join(' ') | firstLetterWordsIntoString ) : ( enumStates[i] | titlecase | uppercase ) }}
                                        </span>
                                    </mat-chip>
                                    <span class="subtitle-3 text-secondary-darker mrs-5">{{ totalByState }}</span>
                                </div>
                            </div>
                        </mat-chip-listbox>
                    </div>
                    <div class="flex-25 mts-3">
                        <span class="ml-5 text-secondary txt" (click)="removeFilters()"
                            style="white-space: nowrap; cursor: pointer;">Limpiar selección</span>
                    </div>
                </div>
                <div *ngIf="this.textButton4" class="flex-row align-space-between-center mts-2"
                    style="background-color: #fafafa; min-width: 100%;">
                    <div class="flex-row align-start-stretch flex-gap-1em flex-75">
                        <span class="subtitle-3 text-secondary ml-5">TOTAL:</span>
                        <span class="mls-1 subtitle-3 text-secondary-darker">{{ this.attenttionsToBillDebit.length }}</span>
                        <span class="subtitle-3 text-secondary ml-5">FACTURAR:</span>
                        <span class="mls-1 subtitle-3 text-secondary-darker">{{ this.totalBill }}</span>
                        <span class="subtitle-3 text-secondary ml-5">DEBITAR:</span>
                        <span class="mls-1 subtitle-3 text-secondary-darker">{{ this.totalDebit }}</span>
                    </div>
                    <a class="flex-25 text-primary mls-4" mat-button
                        (click)="this.attenttionsToBillDebit.length > 0 ? onLocalClickButton4() : null"
                        [disabled]="this.attenttionsToBillDebit.length == 0"
                        [ngClass]="{ btnProcessDisabled: this.attenttionsToBillDebit.length == 0 }"
                        style="font-weight: bolder !important;">
                        CONFIRMAR
                    </a>
                </div>
            </div>
        
    </div>
</div>

<ng-template #noAttentions>
    <div *ngIf="!loading" class=" flex-column mts-4 mbs-4 align-center-center gap-2em" style="align-self: center;">
          <div class="flex align-center-center">
            <mat-icon [svgIcon]="'Empty-Calendar-Disabled'" style="width: 60px; height: 60px; font-size: 60px;"></mat-icon>
        </div>
        <div
            *ngIf="(!!this.dataSourceAttentions && !!this.dataSourceSupplies || (!!this.dataSourceAttentions?.data && this.dataSourceAttentions?.data?.length == 0 && this.actualDateAttentions?.length == 0) && (!!this.dataSourceSupplies?.data && this.dataSourceSupplies?.data?.length == 0 && this.actualDateAttentions?.length == 0))">
            <span class="subtitle-2 text-secondary"> {{selectedOption === MODULE ? textModuleNoAttentions : textNoAttentions}}</span>
        </div>
    </div>
</ng-template>

<ng-template #loadingSpinner>
    <div class="flex-100 pys-2 align-center-start">
        <mat-spinner class="mys-4" color="primary" diameter="40"></mat-spinner>
    </div>
</ng-template>

<mat-menu #menuActions="matMenu">
    <ng-template matMenuContent let-attention="attention">
        <!-- Evolucionar -->
        <button mat-menu-item
            [disabled]="!(this.attentionService.isEvolvable(attention) && attention?.practice?.name != 'Entrega insumos')"
            (click)="openDialog(attention)">Evolucionar</button>
        <!-- Ver remito -->
        <button mat-menu-item [disabled]="!attention.hasEvolutions"
            (click)="onClickEvolutions(attention)">{{attention?.practice?.name == 'Entrega insumos' ? 'Ver remito' :
            'Ver evoluciones'}}</button>
        <!-- Editar -->
        <button mat-menu-item [disabled]="!this.attentionService.isEditable(attention)"
            (click)="onClickUpdate(attention)">Editar</button>
        <!-- Eliminar -->
        <button mat-menu-item [disabled]="!this.attentionService.isDeletable(attention)"
            (click)="onClickDelete(attention)">Eliminar</button>
    </ng-template>
</mat-menu>

<ng-template #deleteWizardAttentions>
    <app-attentions-delete-wizard [caseId]="this.case.id" [provisionAgreements]="this.provisionAgreements"
        [provisionFees]="this.provisionFees"
        (onClickCancelWizard)="clickCancelDeleteWizard()"></app-attentions-delete-wizard>
</ng-template>
